/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";
import { ApiResponse } from "~/foundation/Api/generated-types";
import { ArticleListRequestModel } from "~/foundation/Article/generated-types";

export const articleServiceMeta: Meta<typeof articleService> = {
	latestArticles: ["GET", "/api/v1/article/list/latest"],
	latestArticlesWidget: ["GET", "/api/v1/article/list/widget"],
	latestArticlesIntranetCors: ["GET", "/api/v1/article/list/intranet-cors/latest"],
	countArticles: ["GET", "/api/v1/article/list/count"],
	countArticlesCheck: ["GET", "/api/v1/article/list/countcheck"],
	articlesStatus: ["GET", "/api/v1/article/list/status"],
	share: ["POST", "/api/v1/article/share/:articleId"],
};

// Feature.Article.Controllers.Api.ApiV1ArticleController
export const articleService = {
	async latestArticles(queryStrings: ArticleListRequestModel & { exclude: string }) {
		return await http.fetch<ApiResponse, undefined>(articleServiceMeta.latestArticles, { queryStrings });
	},
	async latestArticlesWidget(queryStrings: ArticleListRequestModel) {
		return await http.fetch<ApiResponse, undefined>(articleServiceMeta.latestArticlesWidget, { queryStrings });
	},
	async latestArticlesIntranetCors(queryStrings: { startIndex: number, length: number }) {
		return await http.fetch<undefined, undefined>(articleServiceMeta.latestArticlesIntranetCors, { queryStrings });
	},
	async countArticles(queryStrings: { sinceDays: number }) {
		return await http.fetch<ApiResponse, undefined>(articleServiceMeta.countArticles, { queryStrings });
	},
	async countArticlesCheck() {
		return await http.fetch<ApiResponse, undefined>(articleServiceMeta.countArticlesCheck, {  });
	},
	async articlesStatus() {
		return await http.fetch<ApiResponse, undefined>(articleServiceMeta.articlesStatus, {  });
	},
	async share(articleId: /* Guid */ string, queryStrings: { articleId: /* Guid */ string }) {
		return await http.fetch<ApiResponse, undefined>(articleServiceMeta.share, { params: { articleId }, queryStrings });
	},
};
